module.exports = __webpack_public_path__ + "static/img/error.72787256.png";